'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.params = void 0;
// params from meter source code and meter foundation's suggestion
const params = {
    defaultGasPriceCoef: 128,
    defaultExpiration: 720,
    TxGas: 5000,
    ClauseGas: 21000 - 5000,
    ClauseGasContractCreation: 53000 - 5000,
    TxDataZeroGas: 4,
    TxDataNonZeroGas: 68,
};
exports.params = params;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGFyYW1zLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3V0aWxzL3BhcmFtcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxZQUFZLENBQUE7OztBQUVaLGtFQUFrRTtBQUNsRSxNQUFNLE1BQU0sR0FBRztJQUNYLG1CQUFtQixFQUFFLEdBQUc7SUFDeEIsaUJBQWlCLEVBQUUsR0FBRztJQUN0QixLQUFLLEVBQUUsSUFBSTtJQUNYLFNBQVMsRUFBRSxLQUFLLEdBQUcsSUFBSTtJQUN2Qix5QkFBeUIsRUFBRSxLQUFLLEdBQUcsSUFBSTtJQUN2QyxhQUFhLEVBQUUsQ0FBQztJQUNoQixnQkFBZ0IsRUFBRSxFQUFFO0NBQ3ZCLENBQUE7QUFHRyx3QkFBTSJ9